import { Timestamp } from '@angular/fire/firestore';
import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { SchoolMemberType } from '../../models/member.school.model';
import { Notice } from '../../models/notice.model';

export const getNotices = createAction(
  '[Notice] Get notices',
  props<{
    groupId: string;
    memberType: SchoolMemberType[];
    academicYear: number;
    gradeId?: string[] | undefined;
    startDate?: Timestamp;
    lastRecord?: any;
  }>(),
);

export const addNoticesToStore = createAction(
  '[Notice] Load Notices to store',
  props<{ notices: Notice[] }>(),
);
export const addNoticeToStore = createAction(
  '[Notice] Load Notice to store',
  props<{ notice: Notice }>(),
);

export const getNotice = createAction(
  '[Notice] Get notice',
  props<{ noticeId: string }>(),
);

export const getNoticesFailure = createAction(
  '[Notice] Get Notices Failed',
  props<{ error: AppExceptionModel }>(),
);

// Create Notice Actions
export const create = createAction(
  '[Notice] Create notice',
  props<{ id: string; notice: Notice }>(),
);
export const createFailure = createAction(
  '[Notice] Create notice failure',
  props<{ error: any }>(),
);
export const createSuccess = createAction(
  '[Notice] Create notice success',
  props<{ notice: Notice }>(),
);

// Update Notice Actions
export const update = createAction(
  '[Notice] Update',
  props<{ groupId: string; id: string; notice: Notice }>(),
);
export const updateFailure = createAction(
  '[Notice] Update failure',
  props<{ error: any }>(),
);
export const updateSuccess = createAction(
  '[Notice] Update success',
  props<{ notice: Notice }>(),
);

// Update Notice Status Actions
export const updateStatus = createAction(
  '[Notice] Update',
  props<{ id: string; notice: Notice }>(),
);
export const updateStatusFailure = createAction(
  '[Notice] Update Status Failure',
  props<{ error: any }>(),
);
export const updateStatusSuccess = createAction(
  '[Notice] Update Status Success',
  props<{ notice: Notice }>(),
);

// Delete Notice Actions
export const deleteAction = createAction(
  '[Notice] Delete',
  props<{ groupId: string; id: string }>(),
);
export const deleteFailure = createAction(
  '[Notice] Delete failure',
  props<{ error: any }>(),
);
export const deleteSuccess = createAction(
  '[Notice] Delete success',
  props<{ id: string }>(),
);

export const clearFromStore = createAction(
  '[Notice] Clear from store',
  props<{ id: string }>(),
);

// export const getNoticeStats = createAction(
//   '[Notice] Get Notice Statistics',
//   props<{ groupId: string }>()
// );
// export const getNoticeStatsDone = createAction(
//   '[Notice] Get Notice Statistics Done',
//   props<{ group: Group }>()
// );
// export const getNoticeStatsFailure = createAction(
//   '[Notice] Notice Statistics Failure',
//   props<{ error: any }>()
// );

export const clear = createAction('[Notice] Clear Notices');
